module.exports = __webpack_public_path__ + "static/img/2AmatchinggrantC7sXY6WOHYy1Mm5zwAe9THeHxU.7a30afb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/originalframerhtml_files/2AmatchinggrantC7sXY6WOHYy1Mm5zwAe9THeHxU.jpg
// module id = K0Y5
// module chunks = 73